import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Sydney production region (`enterprise.au.wisesystems.io`)
 */
export const sydneyServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.au.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    socketServer: 'wss://au.socket.wisesys.info',
    environment: ServerEnvironment.SYDNEY,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    auroraServer: '',
    vehicleProfile:
        'https://6bvb2gb6gd.execute-api.ap-southeast-2.amazonaws.com/Sydney',
    routePathGeometryServer:
        'https://bys6alpaq2.execute-api.ap-southeast-2.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    // TODO(CD-112): regional prod — Cognito differs from dcs-prod; needs own regional dcs stack
    driverCostServer: ''
};
